// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__CVPWh","inputWrap":"styles_inputWrap__2RuOU","input":"styles_input__31mRg"};